export const REQUEST = 'REQUEST';
export const COUNSELING = 'COUNSELING';
export const COMPLETED = 'COMPLETED';
export const COUNSEL_COMPLTED = 'COUNSEL_COMPLETED';
export const SALE = 'SALE';

export const INDIVIDUAL_SMALL = 'INDIVIDUAL_SMALL';
export const INDIVIDUAL_MIDDLE = 'INDIVIDUAL_MIDDLE';
export const INDIVIDUAL_HIGH = 'INDIVIDUAL_HIGH';

export const INDIVIDUAL = 'INDIVIDUAL';
export const INDIVIDUAL_DELIVERY = 'INDIVIDUAL_DELIVERY';
export const GENERAL_CARGO = 'GENERAL_CARGO';
export const BASE_TONNAGE = 16;
